import * as RadixSwitch from '@radix-ui/react-switch';
import { forwardRef } from 'react';
import { CheckIcon, XIcon } from '@phosphor-icons/react';
import styles from './switch.module.scss';

export const Switch = forwardRef<HTMLButtonElement, RadixSwitch.SwitchProps>(
    ({ onChange, ...props }, ref) => {
        const forwardRef = ref;

        return (
            <RadixSwitch.Root {...props} ref={forwardRef} className={styles.root}>
                <CheckIcon className={styles.check} fill="white" size={15} />
                <RadixSwitch.Thumb className={styles.thumb} />
                <XIcon className={styles.x} fill="black" size={15} />
            </RadixSwitch.Root>
        );
    }
);

Switch.displayName = 'Switch';
